<template>
	<div style="background-color:#FFF; padding: 20px;">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center" style="margin-bottom: 20px">
				<h3 class="order-title">ការទូទាត់ប្រាក់ដៃគូសហការ</h3>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="border-collapse: collapse; width: 100%">
					<tr>
						<td class="print-logn-td" style="width: 35%">លេខកូដប្រតិបត្តិការ</td>
						<td class="print-logn-td" style="width: 20px">:</td>
						<td class="print-logn-td"><b>{{$route.params.hash}}</b></td>
					</tr>
					<tr>
						<td class="print-logn-td">ទឹកប្រាក់បានទូទាត់</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b>{{config.moneylify(transaction.amount)}}</b></td>
					</tr>
				</table>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<table style="border-collapse: collapse; width: 100%">
					<tr>
						<td class="print-logn-td" style="width: 35%">ឈ្មោះដៃគូសហការ</td>
						<td class="print-logn-td" style="width: 20px">:</td>
						<td class="print-logn-td"><b>{{transaction.note}} ({{dividend}}%)</b></td>
					</tr>
					<tr>
						<td class="print-logn-td">កាលបរិច្ឆេទទូទាត់</td>
						<td class="print-logn-td">:</td>
						<td class="print-logn-td"><b>{{config.datelify(transaction.created_date)[1]}}</b></td>
					</tr>
				</table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 20px">
				<h4>តារាងចំណូលតាមភាពយន្ត</h4>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<table style="border-collapse: collapse; width: 100%;border:1px solid black; font-weight: 9px !important;margin-top: 10px">
					<thead>
						<tr style="border: 1px solid black;padding: 5px">
							<td class="print-row print-row-bold">ល.រ</td>
							<td class="print-row print-row-bold" style="text-align: left;">ឈ្មោះភាពយន្ត</td>
							<td class="print-row print-row-bold">ចំណូលសរុប</td>
							<td class="print-row print-row-bold">ភាគលាភទទួលបាន</td>
						</tr>
					</thead>

					<tbody>
						<tr v-for="(film, index) in filmList" style="border: 1px solid black">
							<td class="print-row"><b>{{ index + 1}}</b></td>
							<td class="print-row" style="text-align: left;"><b>{{ film.title }}</b></td>
							<td class="print-row">{{config.moneylify(film.total_payment) }}</td>
							<td class="print-row">{{config.moneylify(film.total_payment * dividend / 100) }}</td>
						</tr>
						<tr style="border: 1px solid black">
							<td class="print-row" colspan="2"><b>ចំនួនទឹកប្រាក់សរុប</b></td>
							<td class="print-row"><b>{{config.moneylify(total_payment)}}</b></td>
							<td class="print-row"><b>{{config.moneylify(transaction.amount)}}</b></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.$http.get(this.config.api + "/user/transaction/get/" + this.$route.params.hash).then(data => {
				this.transaction = data.body.data;

                this.$http.get(this.config.api + "/user/transaction/get_film/" + this.$route.params.hash).then(data => {
					this.filmList = data.body.data.list;
                    this.dividend = data.body.data.transaction.dividend;
					this.loaded = true;
					setTimeout(() => {
						window.print();
					}, 1000)
				});
			});
		},
		mounted() { },
		data() {
			return {
				loaded: false,
				filmList: [],
				projectList: [],
                dividend: 0,
				transaction: {
					name: 0,
					hash: 0,
                    amount: 0,
					created_date: 0
				}
			}
		},
		computed: {
			total_payment() {
				let total = 0;

				for(let i =0; i<this.filmList.length; i++) {
					total = total + this.filmList[i].total_payment;
				}
				return total;
			},
            total_dividend() {
                let total = 0;

				for(let i =0; i<this.filmList.length; i++) {
					total = total + this.filmList[i].total_payment * this.dividend / 100;
				}
				return total;
            }
 		}
	}
</script>

<style>
	table {
		page-break-inside:auto;
	}
   tr {
		page-break-inside:avoid;
		page-break-after:auto
	}
   thead {
		display:table-header-group
	}
   tfoot {
		display:table-footer-group
	}

	.no-hover:hover {
		background-color: #FFF !important;
	}
	.center {
		text-align: center;
	}

	body {
		background-color: #FFF !important;
	}
	.print-row-bold {
		font-weight: bold;
	}

	.print-row {
		border: 1px solid black;
		text-align: center;
		padding: 5px;
		font-size: 12px;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
		font-family: 'Moul';
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
	.print-logn-td {
		font-size: 13px;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintPartnerPayment.vue